import { createAction } from 'redux-actions';
import { BillingPublisherAddressType, BillingPublisherType } from '@ts/billing-publisher.types';

export const setPublisherBillingLs = createAction<string>('SET_PUBLISHER_BILLING_LS');
export const setPublisherBillingData = createAction<BillingPublisherType>(
  'SET_PUBLISHER_BILLING_DATA'
);

export const setPublisherBillingAddressLs = createAction<string>(
  'SET_PUBLISHER_BILLING_ADDRESS_LS'
);
export const setPublisherBillingAddressData = createAction<BillingPublisherAddressType>(
  'SET_PUBLISHER_BILLING_ADDRESS_DATA'
);
